export const PAYWALL_PATH = '/admin/plans';

export function buildPaywallUrl({ returnTo, featureKey } = {}) {
    const params = new URLSearchParams();
    if (returnTo) {
        params.set('return', returnTo);
    }
    if (featureKey) {
        params.set('feature', featureKey);
    }
    const query = params.toString();
    return query ? `${PAYWALL_PATH}?${query}` : PAYWALL_PATH;
}

export function readPaywallReturnTo(searchParams) {
    const value = searchParams?.get?.('return') || '';
    if (!value.startsWith('/admin')) {
        return '/admin';
    }
    return value;
}

export function readPaywallFeatureKey(searchParams) {
    return String(searchParams?.get?.('feature') || '').trim();
}
